export const SocialIcon: React.FC = () => {
    return (
        <div className="link-icons">
           
            <a  href='https://wa.link/b8xq56' target='_blank' rel="noreferrer"><ion-icon name="logo-whatsapp"></ion-icon></a>
            <a href="https://x.com/jozzycodes"  target='_blank' rel="noreferrer"><ion-icon name="logo-twitter" ></ion-icon></a>
            <a href="https://web.facebook.com/profile.php?id=61559970704850"  target='_blank' rel="noreferrer"><ion-icon name="logo-facebook"></ion-icon></a>
        </div>
    );
};

